const MalawiSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111816)">
      <path
        d="M19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0Z"
        fill="black"
      />
      <path
        d="M38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957Z"
        fill="#496E2D"
      />
      <path
        d="M25.9779 9.56449L23.5354 8.41559L24.8361 6.05004L22.1838 6.55746L21.8477 3.87793L20.0002 5.84863L18.1528 3.87793L17.8166 6.55746L15.1643 6.05004L16.465 8.41559L14.0225 9.56449H25.9779Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111816">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MalawiSvg;
